import { franc } from 'franc-min';

/**
 * Detect the language of a given content using franc-min package
 * @param content - The content to detect the language of
 * @param minLength - The minimum length of the content to detect the language of
 * @returns The detected language in ISO 639-3 or 'und' if the language could not be detected
 */
export const detectLanguage = (content: string, minLength = 5): string => {
  if (!content) {
    return 'und';
  }

  // Check if the content is a flag
  if (content.includes('THM{')) {
    return 'und';
  }

  return franc(content, { minLength });
};
